/** @flow */
import * as React from 'react';
import MuiDialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Paper from '@material-ui/core/Paper';
import DialogFooter from 'common/components/DialogFooter';
import styled from 'styled-components';

const SDialogTitle = styled(DialogTitle)`
  color: ${({ theme }) => theme.V2.colors.text.tertiary};
  background-color: ${({ theme }) => theme.V2.colors.primary};
`;

const TitleContent = styled.div`
  color: ${({ theme }) => theme.V2.colors.text.tertiary};
`;

// fix for https://github.com/mui-org/material-ui/issues/7431
const SPaper = styled(Paper)`
  overflow: visible;
`;

// fix for https://github.com/mui-org/material-ui/issues/7431
const SDialogContent = styled(DialogContent)`
  overflow: visible;
  
  ${({ scroll }) => (scroll === 'scroll') && `
    overflow-y: scroll;
  `} 
`;

interface Props {
  title: string;
  open: boolean;
  disableScroll: boolean;

  onClose: () => void;

  actions?: React.Node[];
  displayActions: boolean;
  children: any;
}

function stopPropagation(e) {
  e.stopPropagation();
}

export function Dialog({ title, open, actions, displayActions, disableScroll, onClose, children }: Props) {
  const scrollMode = disableScroll ? 'none' : 'scroll';
  return (
    <MuiDialog
      aria-labelledby={title}
      open={open}
      onClose={onClose}
      PaperComponent={SPaper}
      fullWidth
      scroll="paper"
      onClick={stopPropagation}
    >
      <SDialogTitle><TitleContent>{title}</TitleContent></SDialogTitle>
      <SDialogContent scroll={scrollMode}>{children}</SDialogContent>
      { actions && actions.length > 0 && displayActions && <DialogFooter>{actions}</DialogFooter>}
    </MuiDialog>
  );
}

Dialog.defaultProps = {
  displayActions: true,
  disableScroll: false,
};



// WEBPACK FOOTER //
// ./src/common/components/ui/Dialog.js